type User = {
    id: number,
    uid: string,
    name: string,
    lastname: string,
    nickname: string,
    email: string,
    url_avatar: string,
    role_id: number
    created_at?: Date,
    cid?: string
};

class UserFactory {
    public static create(
        id: number,
        uid: string,
        name: string,
        lastname: string,
        nickname: string,
        email: string,
        url_avatar: string,
        role_id: number,
        created_at?: Date,
        cid?: string
    ): User {
        return {
            id,
            uid,
            name,
            lastname,
            nickname,
            email,
            url_avatar,
            role_id,
            created_at,
            cid
        };
    }
}

type UserStats = {
    last_activity: string,
    total_missions: number,
    total_missions_month: number
};

class UserStatsFactory {
    public static create(
        last_activity: string,
        total_missions: number,
        total_missions_month: number
    ): UserStats {
        return {
            last_activity,
            total_missions,
            total_missions_month
        };
    }
}

type AuthResponse = {
    displayName: string,
    email: string,
    expiresIn: string,
    idToken: string,
    kind: string,
    refreshToken: string,
    registered: boolean,
    uid: string,
};

class AuthResponseFactory {
    public static create(
        displayName: string,
        email: string,
        expiresIn: string,
        idToken: string,
        kind: string,
        refreshToken: string,
        registered: boolean,
        uid: string,
    ): AuthResponse {
        return {
            displayName,
            email,
            expiresIn,
            idToken,
            kind,
            refreshToken,
            registered,
            uid,
        };
    }
}

type TokenResponse = {
    access_token: string,
    expires_in: string,
    token_type: string,
    refresh_token: string,
    id_token: string,
    user_id: string,
    project_id: string
};

class TokenResponseFactory {
    public static create(
        access_token: string,
        expires_in: string,
        token_type: string,
        refresh_token: string,
        id_token: string,
        user_id: string,
        project_id: string
    ): TokenResponse {
        return {
            access_token,
            expires_in,
            token_type,
            refresh_token,
            id_token,
            user_id,
            project_id
        };
    }
}


export { User, UserFactory, UserStats, UserStatsFactory, AuthResponse, AuthResponseFactory, TokenResponse, TokenResponseFactory };
